module.exports = __webpack_public_path__ + "img/ltkaustralia-4x.01ebe4b.jpg";